import React, { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { ReactComponent as GoogleIcon } from "../../assets/google.svg";
import AuthSpinner from "../ui/AuthSpinner";

const LoginButton: React.FC = () => {
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [authStep, setAuthStep] = useState<
    "authenticating" | "verifying" | "connecting" | "success"
  >("authenticating");
  const [isSuccess, setIsSuccess] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const contactToken = urlParams.get("contact_token");

  const login = useGoogleLogin({
    scope: "openid email profile",
    onSuccess: async (tokenResponse) => {
      setIsAuthenticating(true);
      setAuthStep("verifying");

      let baseUrl = process.env.REACT_APP_SERVER_URL || "";
      if (baseUrl.endsWith("/")) {
        baseUrl = baseUrl.slice(0, -1);
      }

      try {
        setAuthStep("connecting");
        const response = await fetch(`${baseUrl}/auth/google/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            access_token: tokenResponse.access_token,
            id_token: (tokenResponse as { id_token?: string }).id_token,
            contact_token: contactToken,
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        const authToken = data.access_token;
        const refreshToken = data.refresh_token;

        localStorage.setItem("accessToken", authToken);
        localStorage.setItem("refreshToken", refreshToken);

        setAuthStep("success");
        setIsSuccess(true);

        setTimeout(() => {
          window.location.href = "/";
        }, 1500);
      } catch (error) {
        console.error("Backend login failed:", error);
        setIsAuthenticating(false);
        setAuthStep("authenticating");
        setIsSuccess(false);
      }
    },
    onError: () => {
      console.error("Google login failed");
      setIsAuthenticating(false);
      setAuthStep("authenticating");
      setIsSuccess(false);
    },
  });

  if (isAuthenticating) {
    return <AuthSpinner step={authStep} isSuccess={isSuccess} />;
  }

  return (
    <button
      onClick={() => login()}
      className="flex items-center gap-2 lg:gap-3 bg-white text-gray-800 border border-gray-300 rounded-lg shadow px-4 lg:px-5 py-2 lg:py-3 hover:shadow-lg hover:bg-gray-50 hover:scale-105 transition-all duration-200 active:scale-95"
    >
      <GoogleIcon className="w-4 h-4 lg:w-5 lg:h-5" />
      <span className="font-medium text-xs lg:text-sm">
        Sign in with Google
      </span>
    </button>
  );
};

export default LoginButton;
